import { useState } from 'react';
import Copy from 'copy-to-clipboard';

import Typography from 'components/CncUI/Typography';
import TextField from 'components/CncUI/TextField';
import Snackbar from 'components/CncUI/Snackbar';

import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import FileCopy from '@material-ui/icons/FileCopy';

const useStyles = makeStyles(({ palette, breakpoints }) => ({
  center: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 24,
    '& .MuiInput-underline:before': {
      border: '0 !important',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      border: '0 !important',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):after': {
      border: '0 !important',
    },
  },
  title: {
    fontWeight: 400,
    marginTop: 52,
  },
  subTitle: {
    color: '#5c5c5c !important',
    [breakpoints.down('sm')]: {
      padding: '0 20px',
    },
  },
  secretKey: {
    width: 300,
    borderRadius: 2,
    backgroundColor: '#edf6fb',
    padding: '8px 0 6px 12px',
    fontSize: 26,
    color: `${palette.cncUI.misc.link} !important`,
  },
  mobileSecretKey: {
    backgroundColor: '#edf6fb',
    padding: 0,
    '& .MuiInputBase-root': {
      padding: '2px 0 2px 4px',
      fontSize: 24,
      color: `${palette.cncUI.misc.link} !important`,
      '& input': {
        position: 'relative',
        left: 12,
      },
    },
  },
  code: {
    width: 210,
    marginTop: 20,
    [breakpoints.down('sm')]: {
      width: 300,
    },
  },
  copy: {
    color: `${palette.cncUI.misc.link} !important`,
    '& p': {
      color: `${palette.cncUI.misc.link} !important`,
    },
  },
}));

const SecretKey = props => {
  const classes = useStyles();
  const [alert, setAlert] = useState({
    message: 'Copied to clipboard',
    title: 'Success',
    type: 'success',
    show: false,
  });
  const { code, setCode, factor, isMobile } = props;
  const { activation } = JSON.parse(factor.embedded);
  const notify = data => setAlert(old => ({ ...old, ...data }));

  const copy = () => {
    const copied = Copy(activation.sharedSecret, {
      message: 'Press #{key} to copy',
      format: 'text/plain',
    });
    if (copied) {
      notify({
        message: 'Copied to clipboard',
        title: 'Success',
        type: 'success',
        show: true,
      });
    } else {
      notify({
        message:
          'Sorry we could not copy the code for you, please copy manually.',
        title: 'Error',
        type: 'error',
        show: true,
      });
    }
  };

  return (
    <>
      <Snackbar
        title={alert.title}
        open={alert.show}
        onClose={() => notify({ show: false })}
        position="top-center"
        hideDuration={4500}
        inline
        variant={alert.type}
      >
        {alert.message}
      </Snackbar>
      <Grid item xs={12}>
        <div className={classes.center}>
          {isMobile ? (
            <TextField
              className={classes.mobileSecretKey}
              id="SecretKeyInput"
              value={activation.sharedSecret}
              endIcon={
                <IconButton
                  aria-label="Copy"
                  onClick={copy}
                  className={classes.copy}
                  id="SecretKey-copyButton"
                >
                  <FileCopy />
                  <Typography variant="body1">Copy</Typography>
                </IconButton>
              }
            />
          ) : (
            <span className={classes.secretKey}>{activation.sharedSecret}</span>
          )}
        </div>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h4" className={classes.title}>
          Enter Code
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" className={classes.subTitle}>
          A six digit code will be displayed in your Okta Verify application
          after entering the secret key listed above. Enter the six digit code
          in the text field below and verify.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <TextField
          light
          className={classes.code}
          id="SecretKeyEnterCodeInput"
          placeholder="Enter code here"
          value={code}
          onChange={e => setCode(e.target.value.replace(/\D/g, ''))}
          autoComplete="one-time-code"
          autoFocus
          inputProps={{
            pattern: '[0-9]*',
            inputMode: 'numeric',
          }}
        />
      </Grid>
    </>
  );
};

export default SecretKey;
